module.exports = __webpack_public_path__ + "static/media/smiling-face.eb5d1785.svg";